export default __webpack_public_path__ + "static/media/nigeria.5179b860.svg";